import { ReportPage, User } from "./index";

export class ReportNote {
    ID: number;
    PAGE: ReportPage;
    CREATED_BY: User;
    TEXT: string;
    CREATED: string;
    CREATED_FORMATTED: string;
    INCLUDE_IN_REPORT: boolean = false;

    static parse(json: any): ReportNote {
        if (json) {
            const rn = new ReportNote();

            rn.ID = json.ID;
            if(json.PAGE)
                rn.PAGE = ReportPage.parse(json.PAGE);
            if(json.CREATED_BY)
                rn.CREATED_BY = User.parse(json.CREATED_BY);

            rn.TEXT = json.TEXT;
            rn.CREATED = json.CREATED;
            rn.CREATED_FORMATTED = json.CREATED_FORMATTED;
            rn.INCLUDE_IN_REPORT = json.INCLUDE_IN_REPORT;

            return rn;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<ReportNote> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(ReportNote.parse(j));

        return arr;
    }
}
